var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.pageTitle } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-row",
            { staticClass: "pb-3 no-gutter" },
            [_c("back-button", { attrs: { returnUrl: "/security/0" } })],
            1
          ),
          _vm._v(" "),
          _c("ca-form-global", {
            attrs: { mode: _vm.mode, id: _vm.id, readonly: !_vm.isEditable },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }